import ApiService from '@/core/services/api.service';
import { SET_PERMISSION } from '@/core/services/store/modules/permission.module';

const getPermissionsMixin = {
  async created() {
    await this.getPermissions();
  },
  methods: {
    async getPermissions() {
      await ApiService.get('permissions/').then((response) => {
        const permissions = response.data?.data || [];
        this.$store.dispatch(SET_PERMISSION, permissions);
      });
    },
  },
};
export default getPermissionsMixin;
